export default __webpack_public_path__ + "static/media/pexels-tima-miroshnichenko-5198239.eab0731d.jpg";